import { VueConstructor } from "vue"
import { DateTime, Settings } from 'luxon';
Settings.defaultLocale = 'pt-BR';

export const NumberFormatter = {
    install(Vue: VueConstructor) {
        Vue.filter('number_format', (value: number): string => {
            if (!value) {
                return ''
            }
            return new Intl.NumberFormat("pt-BR", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        })
    }
}

export const DateFilter = (value: string | Date | null, format: string = 'dd/LL/yyyy'): string => {
    if (!value) {
        return ''
    }
    if ('string' == typeof value) {

        return DateTime.fromSQL(value).toFormat(format);
    } else {
        return DateTime.fromJSDate(value).toFormat(format);
    }
}

export const DateFormatter = {
    install(Vue: VueConstructor) {
        Vue.filter('date', (value: string|Date|null, format = 'dd/LL/yyyy') => {
            return DateFilter(value, format)
        });
    }
}